<script lang="ts">
  import Footer from "@modern/components/retailer/reports/Footer.svelte";
  import Header from "@modern/components/retailer/reports/Header.svelte";
  import ReportsTable from "@modern/components/retailer/reports/Orders/ReportsTable.svelte";
  import SearchAndFilter from "@modern/components/retailer/reports/SearchAndFilter.svelte";
  import { getQueryParams } from "@modern/utils/queryparams";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Flash from "@shared/services/flashv2";
  import { onMount } from "svelte";
  import moment from "moment";

  const queryParams = getQueryParams();
  let startDate =
    queryParams.get("startDate") || moment(new Date()).subtract(60, "days").format("YYYY-MM-DD");
  let endDate = queryParams.get("endDate") || moment(new Date()).format("YYYY-MM-DD");
  let distributorSearch = queryParams.get("distributorSearch") || "";
  let reports = [];

  const fetchReports = async () => {
    if (!startDate || !endDate) return;

    try {
      reports = await HttpPromise({
        method: "GET",
        url: "/api/retailer/reports/orders_detail",
        data: {
          start_date: startDate,
          end_date: endDate,
          distributor_search: distributorSearch,
        },
      });
    } catch (error) {
      Flash.now({
        message: "There was an error while fetching reports overview. Please contact support",
        type: "error",
      });
    }
  };

  onMount(async () => {
    await fetchReports();
  });

  const setParams = async () => {
    const searchParams = getQueryParams();
    searchParams.set("startDate", startDate);
    searchParams.set("endDate", endDate);

    distributorSearch.length > 0
      ? searchParams.set("distributorSearch", distributorSearch)
      : searchParams.delete("distributorSearch");

    window.history.pushState(searchParams, "", `${window.location.pathname}?${searchParams}`);
  };

  const refreshData = async () => {
    await setParams();
    await fetchReports();
  };

</script>

<Header {startDate} {endDate} message="Orders by Distributor Report" />
<SearchAndFilter
  bind:startDate
  bind:endDate
  bind:search={distributorSearch}
  {refreshData}
  placeholder="Search Distributors"
/>
<ReportsTable reportsOrdersDetail={reports} {startDate} {endDate} />
<div class="fizz-styles"><Footer /></div>
